import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { eng } from './en';
import { esp } from './es';
import { pt } from './pt';

i18n
  .use(LanguageDetector)
  .use(initReactI18next).init({
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    resources: {
      en: {
        translation: eng,
      },
      es: {
        translation: esp,
      },
      pt: {
        translation: pt,
      },
    },
  });

export default i18n;
